import { z } from 'zod';
import { paginationQuery } from './common.js';
const shortText = (max) => z.string().trim().max(max).nullable().optional();
const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable()
    .optional();
export const teamWritable = z.object({
    name: z.string().trim().min(1).max(120),
    shortName: shortText(40),
    seasonLabel: shortText(40),
    ageClass: shortText(20),
    youthOrSenior: z.enum(['youth', 'senior']).nullable().optional(),
    league: shortText(120),
    division: shortText(120),
    notes: shortText(5000),
});
export const createTeamRequest = teamWritable;
export const updateTeamRequest = teamWritable.partial();
export const teamListQuery = paginationQuery.extend({
    seasonLabel: z.string().optional(),
    youthOrSenior: z.enum(['youth', 'senior']).optional(),
});
/** Central member↔team assignment — the single source of truth (§3, §11). */
export const teamAssignmentWritable = z.object({
    memberId: z.string().uuid(),
    role: z.string().trim().max(40).default('player'),
    isRegular: z.boolean().default(false),
    isSubstitute: z.boolean().default(false),
    isCaptain: z.boolean().default(false),
    validFrom: isoDate,
    validTo: isoDate,
    seasonLabel: shortText(40),
});
export const updateTeamAssignmentRequest = teamAssignmentWritable
    .omit({ memberId: true })
    .partial();
//# sourceMappingURL=team.js.map